
export { useSurveyDetails } from "/home/runner/work/capsicum/capsicum/libs/features/survey/shared/src/hooks/useSurveyDetails.ts"